import { Command, CommandItem, CommandList } from '@ibsys/kit';
import { FC } from 'react';
import type { ReportKnowledgeSuggestion } from '../model';

type Props = {
  nodes: ReportKnowledgeSuggestion[];
  onSelect: (nodeId: number) => void;
};

/**
 * Выпадающий список узлов знаний под полем комментария.
 *
 * Список сужается запросом по набранному после `@`, поэтому фильтрация Command отключена,
 * а поля поиска у него нет: набор идёт в самом редакторе.
 */
export const KnowledgeNodeSuggestionsList: FC<Props> = ({ nodes, onSelect }) => (
  <Command
    shouldFilter={false}
    className="absolute left-0 right-0 top-full z-50 mt-1 rounded-md border bg-popover shadow-md"
  >
    <CommandList className="max-h-40">
      {nodes.map((node) => (
        <CommandItem
          key={node.id}
          value={String(node.id)}
          className="cursor-pointer"
          // Выбор узла не должен уводить фокус с поля: уход фокуса сохраняет правку и закрывает окно
          onMouseDown={(e) => e.preventDefault()}
          onSelect={(value) => onSelect(Number(value))}
        >
          {node.name}
        </CommandItem>
      ))}
    </CommandList>
  </Command>
);
